<template>
    <el-form :model="devicePatrolPeriod" ref="voucherInfo">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">机构名称</label>
                </div>
                <div class="form-value  width-2x">
                    <el-form-item prop="shopName" :rules="{validator: checkNull, trigger: 'blur'}">
                        <el-input class="bottom-line width-1-5x" v-model="devicePatrolPeriod.shopName" :disabled="true"></el-input>
                        <i v-if="devicePatrolPeriod.id == null" class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择机构" @click="showComDlg"></i>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">开始时间</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="startTime" :rules="{validator: checkStartTime, trigger: 'blur'}">
                        <el-time-select placeholder="选择开始时间" v-model="devicePatrolPeriod.startTime" :picker-options="{start: '00:00',step: '00:10',end: '23:50'}"></el-time-select>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">结束时间</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="endTime" :rules="{validator: checkEndTime, trigger: 'blur'}">
                        <el-time-select placeholder="选择结束时间" v-model="devicePatrolPeriod.endTime" :picker-options="{start: '00:10',step: '00:10',end: '24:00',minTime: devicePatrolPeriod.startTime}"></el-time-select>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>说明</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="desc">
                        <el-input type="textarea" v-model="devicePatrolPeriod.desc"></el-input>
                    </el-form-item>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { openRetailComTreeSelectDlg } from './selectDlg';

    import shopDevcApi from '../../api/shopDevc'
    import retailerApi from  '../../api/retailer'

    export default {
        name: 'swb-device-patrol-period-save',
        desc: '巡检时段安排',
        props: ['id', 'defComId'],
        data: function () {
            return {
                devicePatrolPeriod: {
                    id: null,
                    shopId: null,
                    shopName: null,
                    startTime: null,
                    endTime: null,
                    desc: null,
                    timeFrame: [new Date(2020, 9, 14, 8, 0), new Date(2020, 9, 14, 10, 0)]
                },
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() <= Date.now() - 8.64e7;
                    }
                },
                pickerOptions1: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
            }
        },
        created: function () {
            this.getRetailerShopById(this.defComId);
            if(!Utils.isNoB(this.id)) {
                this.getDevicePatrolPeriod(this.id);
            }
        },
        methods: {
            getDevicePatrolPeriod(id){
                let self = this;
                let msgBox = MsgBox.loading();
                let postData = {};
                postData.id = id;
                shopDevcApi.getDevicePatrolPeriodById(postData, function (result) {
                    msgBox.hide();
                    if(result.type == "info") {
                        self.devicePatrolPeriod = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getRetailerShopById: function (defComId) {
                let self = this;
                let devicePatrolPeriod = self.devicePatrolPeriod;
                retailerApi.getRetailerCom({ comId: defComId}, function (result) {
                    if(result.type == "info") {
                        let retailerShop = result.data;
                        devicePatrolPeriod.shopId = retailerShop.bizUnitId;
                        devicePatrolPeriod.shopName = retailerShop.bizUnitName;
                        self.devicePatrolPeriod = Utils.merge({}, devicePatrolPeriod);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            startTimeChange(){
                let startTime = this.devicePatrolPeriod.startTime;
                if(Utils.isNoB(startTime)) {
                    startTime = Date.now();
                } else {
                    startTime = Date.parse(startTime);
                }
                this.pickerOptions1 = {
                    disabledDate(time) {
                        return time.getTime() < startTime - 8.64e7;
                    }
                }
            },
            checkNull: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            },
            checkStartTime: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请选择开始时间!'));
                } else {
                    callback();
                }
            },
            checkEndTime(rule, value, callback){
                if(Utils.isNoB(value)) {
                    callback(new Error('请选择结束时间!'));
                } else {
                    callback();
                }
            },
            showComDlg(){
                let self = this;
                let devicePatrolPeriod = self.devicePatrolPeriod;
                let dlgConfig = {};
                dlgConfig.isRadio = true;
                dlgConfig.isShowIcons = false;
                dlgConfig.enableSearch = true;
                dlgConfig.title = '机构--选择';
                openRetailComTreeSelectDlg(dlgConfig, function (result) {
                    devicePatrolPeriod.shopId = result.id;
                    devicePatrolPeriod.shopName = result.name;
                    self.devicePatrolPeriod = Utils.merge({}, devicePatrolPeriod);
                });
            },
            getDlgResult(){
                let self = this;
                let devicePatrolPeriod = this.devicePatrolPeriod;
                let result = {};
                self.$refs['voucherInfo'].validate(function (valid) {
                    if(valid) {
                        let postData = {
                            id: devicePatrolPeriod.id,
                            shopId: devicePatrolPeriod.shopId,
                            startTime: devicePatrolPeriod.startTime.format("yyyy-MM-dd HH:mm"),
                            endTime: devicePatrolPeriod.endTime.format("yyyy-MM-dd HH:mm"),
                            desc: devicePatrolPeriod.desc
                        };
                        result.type = "info";
                        result.data = postData;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/DevicePatrolPeriodSave.vue